import { useMediaQuery } from '@mui/material';
import axios from 'axios';
import React, { useEffect } from 'react';
import { Navigate, Route, Routes } from 'react-router-dom';
import AppLayout from '../../Components/AppLayout';
import AuthLayout from '../../Components/AuthLayout';
import NestedPageLayout from '../../Components/NestedPageLayout';
import KenLoader from '../../GlobalComponents/KenLoader';
import { useAppContext } from '../../Helpers/Contexts/appContext';
import { KEY_AZURE_TOKEN } from '../../Helpers/constant';
import { getAxiosInstance, getConfig } from '../../Utils/apiService';
import { PrivateRoute, PublicRoute } from '../../Utils/helperFunctions';
import routes from '../../Utils/routes';
import { ConfigOptions } from '../../interfaces/Common';

import GoalsAndMilestonesData from '../Milestones/components/MileStoneData';
import AddMilestones from '../Milestones/addmilestones';
import ViewALLOffers from '../Deals/Pages/ViewALLOffers';
import ViewAllCoe from '../Deals/Pages/ViewAllCoe';

const MyProfile = React.lazy(() => import('../MyProfile'));
const ProfileDetails = React.lazy(() => import('../MyProfile/ProfileDetails'));

// chat
const Chat = React.lazy(() => import('../../Components/Chat'));
const Notifications = React.lazy(() => import('../../Components/Notifications'));
// auth
const Login = React.lazy(() => import('../Auth/Login/index'));
const OnBoarding = React.lazy(() => import('../OnBoarding/index'));
const ConnectSocials = React.lazy(() => import('../Auth/ConnectSocials'));
// home
const Home = React.lazy(() => import('../Home/index'));
const SpotlightDetails = React.lazy(() => import('../Home/SpotlightDetails'));

// goals and milestones
const GoalsAndMilestones = React.lazy(() => import('../Milestones/index'));
// const GoalsAndMilestonesData = React.lazy(() => import('../Milestones/MileStoneData/index'));

//mentors
const Mentors = React.lazy(() => import('../Mentors'));
const FeaturedMentors = React.lazy(() => import('../Mentors/FeaturedMentors'));
const MentorDetailPage = React.lazy(() => import('../Mentors/components/Mentorsdetails'));

const PortfolioDetails = React.lazy(() => import('../../Components/PortfolioDetails/PortfolioDetails'));
const EngagementSummaryDetails = React.lazy(() => import('../../Components/PortfolioDetails/EngagementSummaryDetails'));

// startups
const Startups = React.lazy(() => import('../Network/Startups'));
// events
const Events = React.lazy(() => import('../Events'));
const EventDetails = React.lazy(() => import('../Events/pages/EventDetails/index'));
const HostEvent = React.lazy(() => import('../Events/pages/HostEvent/index'));
const RegisteredEvents = React.lazy(() => import('../Events/pages/RegisteredEvents'));
// participate -> programs
const Programs = React.lazy(() => import('../Programs'));
const ProgramDetails = React.lazy(() => import('../Programs/ProgramDetails'));
// participate -> Challenges
const Challenges = React.lazy(() => import('../Participate/Challenges'));
// people
const People = React.lazy(() => import('../Network/People'));
const PeopleDetails = React.lazy(() => import('../Network/People/components/PeopleDetails'));
//Groups
const Groups = React.lazy(() => import('../Network/Groups/index'));
const DiscoverGroups = React.lazy(() => import('../Network/Groups/DiscoverGroups'));
const CreateGroup = React.lazy(() => import('../Network/Groups/CreateGroup'));
const DiscoverGroupsDetails = React.lazy(() => import('../Network/Groups/DiscoverGroupsDetails'));
const YourGroups = React.lazy(() => import('../Network/Groups/Your Groups'));
// coe
const COE = React.lazy(() => import('../COE'));
const COEDetails = React.lazy(() => import('../COE/COEDetails'));
// support
const Support = React.lazy(() => import('../Support'));
const TicketPreview = React.lazy(() => import('../Support/components/Ticket/TicketPreview'));
const Answers = React.lazy(() => import('../Support/components/Questions/Answers'));
const FAQs = React.lazy(() => import('../Support/FAQs'));
const FaqQuestions = React.lazy(() => import('../Support/FAQs/FaqQuestions'));
const RaiseEnquiry = React.lazy(() => import('../Support/components/RaiseEnquiry'));
// mentors

// deals
const Deals = React.lazy(() => import('../Deals'));
const DealsDetails = React.lazy(() => import('../Deals/Pages/DealsDetails'));
const RaiseRequest = React.lazy(() => import('../Support/components/RaiseRequest'));

//Not Found
const NotFound = React.lazy(() => import('../404'));

// MyPortfolio
// const MyPortfolio = React.lazy(() => import('../MyPortfolio'));
// const FundPortfolio = React.lazy(() => import('../MyPortfolio/FundPortfolio'));
// const RecentReports = React.lazy(() => import('../MyPortfolio/RecentReports'));

const MainLayout: React.FunctionComponent = () => {
  const {
    dispatch,
    state: { config },
  } = useAppContext();
  const isMobile = useMediaQuery('(max-width:700px)');

  useEffect(() => {
    getConfig()
      .then((res: Array<ConfigOptions>) => {
        dispatch({ type: 'updateConfig', value: res[0]?.config });
        dispatch({ type: 'updateLogo', value: res[0]?.config?.Logo });
        getAxiosInstance(res);
        try {
          axios({ method: 'get', baseURL: res[0]?.config?.tokenUrl })
            .then((response: any) => {
              localStorage.setItem(KEY_AZURE_TOKEN, response.data.access_token);
            })
            .catch((err) => {
              return err;
            });
        } catch (err) {
          console.error(err);
        }
      })
      .catch((err) => {
        console.error('error in config', err);
      });
  }, []);

  const ResponsiveLayout = ({ children }: any) => {
    return isMobile ? <NestedPageLayout>{children}</NestedPageLayout> : <AppLayout>{children}</AppLayout>;
  };

  return (
    <>
      <Routes>
        {/* Initial Route */}
        <Route path="/" element={<Navigate to={routes.login} />} />
        {/* Public Routes */}
        <Route
          path={routes.login}
          index
          element={
            <PublicRoute>
              <AuthLayout>
                <Login />
              </AuthLayout>
            </PublicRoute>
          }
        />
        {/* <Route
          path={routes.otpverification}
          element={
            <PublicRoute>
              <AuthLayout>
                <VerifyOTP />
              </AuthLayout>
            </PublicRoute>
          }
        />
        <Route
          path={routes.emailverification}
          element={
            <PublicRoute>
              <AuthLayout>
                <EmailConformation />
              </AuthLayout>
            </PublicRoute>
          }
        />
        <Route
          path={routes.forgotPassword}
          element={
            <PublicRoute>
              <AuthLayout>
                <ForgotPassword />
              </AuthLayout>
            </PublicRoute>
          }
        />
        <Route
          path={routes.signup}
          element={
            <PublicRoute>
              <AuthLayout>
                <Signup />
              </AuthLayout>
            </PublicRoute>
          }
        />
        <Route
          path={routes.changePassword}
          element={
            <PublicRoute>
              <AuthLayout>
                <ConfirmPassword />
              </AuthLayout>
            </PublicRoute>
          }
        /> */}
        {/* Private Routes */}
        <Route
          path={routes.onboarding}
          element={
            <PrivateRoute>
              <AuthLayout>
                <OnBoarding />
              </AuthLayout>
            </PrivateRoute>
          }
        />
        <Route
          path={routes.connectSocials}
          element={
            <PrivateRoute>
              <AuthLayout>
                <ConnectSocials />
              </AuthLayout>
            </PrivateRoute>
          }
        />
        {/* My Profile */}
        <Route
          path={routes.profile}
          element={
            <PrivateRoute>
              <AppLayout>
                <MyProfile />
              </AppLayout>
            </PrivateRoute>
          }
        />
        <Route
          path={routes.profileDetails}
          element={
            <PrivateRoute>
              <AppLayout>
                <ProfileDetails />
              </AppLayout>
            </PrivateRoute>
          }
        />
        <Route
          path={routes.notifcation}
          element={
            <PrivateRoute>
              <AppLayout>
                <Notifications />
              </AppLayout>
            </PrivateRoute>
          }
        />
        <Route
          path={routes.chat}
          element={
            <PrivateRoute>
              <AppLayout>
                <Chat />
              </AppLayout>
            </PrivateRoute>
          }
        />
        {/* Home */}
        <Route
          path={routes.home}
          element={
            <PrivateRoute>
              <AppLayout>
                <Home />
              </AppLayout>
            </PrivateRoute>
          }
        />
        <Route
          path={routes.featureStory}
          element={
            <PrivateRoute>
              <AppLayout>
                <SpotlightDetails />
              </AppLayout>
            </PrivateRoute>
          }
        />

        {/* Goals And Milestones */}
        <Route
          path={routes.goalsAndMilestones}
          element={
            <PrivateRoute>
              <AppLayout>
                <GoalsAndMilestones />
              </AppLayout>
            </PrivateRoute>
          }
        />
        <Route
          path={routes.addgoalmilestones}
          element={
            <PrivateRoute>
              <AppLayout>
                <AddMilestones />
              </AppLayout>
            </PrivateRoute>
          }
        />

        {/* Goals And Milestones Data*/}
        <Route
          path={routes.goalsAndMilestonesData}
          element={
            <PrivateRoute>
              <AppLayout>
                <GoalsAndMilestonesData />
              </AppLayout>
            </PrivateRoute>
          }
        />

        {/* mentors */}

        <Route
          path={routes.mentors}
          element={
            <PrivateRoute>
              <AppLayout>
                <Mentors />
              </AppLayout>
            </PrivateRoute>
          }
        />
        <Route
          path={routes.featuredmentors}
          element={
            <PrivateRoute>
              <AppLayout>
                <FeaturedMentors />
              </AppLayout>
            </PrivateRoute>
          }
        />
        <Route
          path={routes.mentorsdetails}
          element={
            <PrivateRoute>
              <AppLayout>
                <MentorDetailPage />
              </AppLayout>
            </PrivateRoute>
          }
        />

        {/* Participate */}
        {/* Events */}
        <Route
          path={routes.events}
          element={
            <PrivateRoute>
              <AppLayout>
                <Events />
              </AppLayout>
            </PrivateRoute>
          }
        />
        <Route
          path={`${routes.eventDetail}/:eventId`}
          element={
            <PrivateRoute>
              <AppLayout>
                <EventDetails />
              </AppLayout>
            </PrivateRoute>
          }
        />
        <Route
          path={routes.registeredEvents}
          element={
            <PrivateRoute>
              <AppLayout>
                <RegisteredEvents />
              </AppLayout>
            </PrivateRoute>
          }
        />

        <Route
          path={`${routes.hostEvent}`}
          element={
            <PrivateRoute>
              <AppLayout>
                <HostEvent />
              </AppLayout>
            </PrivateRoute>
          }
        />
        {/* Programs */}
        <Route
          path={routes.program}
          element={
            <PrivateRoute>
              <AppLayout>
                <Programs />
              </AppLayout>
            </PrivateRoute>
          }
        />
        <Route
          path={`${routes.programdetails}`}
          element={
            <PrivateRoute>
              <AppLayout>
                <ProgramDetails />
              </AppLayout>
            </PrivateRoute>
          }
        />
        {/* Challenges */}
        <Route
          path={routes.challenges}
          element={
            <PrivateRoute>
              <AppLayout>
                <Challenges />
              </AppLayout>
            </PrivateRoute>
          }
        />

        {/* My Portfolio */}

        <Route
          path={`${routes.myPortfolio}/:Id`}
          element={
            <PrivateRoute>
              <AppLayout>
                <PortfolioDetails />
              </AppLayout>
            </PrivateRoute>
          }
        />

        <Route
          path={`${routes.engagementrSummaryDetails}`}
          element={
            <PrivateRoute>
              <AppLayout>
                <EngagementSummaryDetails />
              </AppLayout>
            </PrivateRoute>
          }
        />
        {/* Groups */}
        <Route
          path={`${routes.groups}`}
          element={
            <PrivateRoute>
              <AppLayout>
                <Groups />
              </AppLayout>
            </PrivateRoute>
          }
        />
        <Route
          path={`${routes.discoverGroups}`}
          element={
            <PrivateRoute>
              <AppLayout>
                <DiscoverGroups />
              </AppLayout>
            </PrivateRoute>
          }
        />
        <Route
          path={`${routes.yourGroups}`}
          element={
            <PrivateRoute>
              <AppLayout>
                <YourGroups />
              </AppLayout>
            </PrivateRoute>
          }
        />
        <Route
          path={`${routes.discoverGroups}/:groupId`}
          element={
            <PrivateRoute>
              <AppLayout>
                <DiscoverGroupsDetails />
              </AppLayout>
            </PrivateRoute>
          }
        />
        <Route
          path={`${routes.createGroup}`}
          element={
            <PrivateRoute>
              <AppLayout>
                <CreateGroup />
              </AppLayout>
            </PrivateRoute>
          }
        />
        {/* Startups */}
        <Route
          path={routes.startups}
          element={
            <PrivateRoute>
              <AppLayout>
                <Startups />
              </AppLayout>
            </PrivateRoute>
          }
        />
        <Route
          path={`${routes.startups}/:Id`}
          element={
            <PrivateRoute>
              <AppLayout>
                <PortfolioDetails />
              </AppLayout>
            </PrivateRoute>
          }
        />
        {/*People */}
        <Route
          path={routes.people}
          element={
            <PrivateRoute>
              <AppLayout>
                <People />
              </AppLayout>
            </PrivateRoute>
          }
        />
        <Route
          path={`${routes.people}/:eventId`}
          element={
            <PrivateRoute>
              <AppLayout>
                <PeopleDetails />
              </AppLayout>
            </PrivateRoute>
          }
        />

        {/* COE */}
        <Route
          path={`${routes.coe}`}
          element={
            <PrivateRoute>
              <AppLayout>
                <Support />
              </AppLayout>
            </PrivateRoute>
          }
        />

        <Route
          path={`${routes.coe}/:Id`}
          element={
            <PrivateRoute>
              <AppLayout>
                <COEDetails />
              </AppLayout>
            </PrivateRoute>
          }
        />

        <Route
          path={`${routes.deals}/:Id`}
          element={
            <PrivateRoute>
              <AppLayout>
                <COEDetails />
              </AppLayout>
            </PrivateRoute>
          }
        />
        {/* Deals */}
        <Route
          path={`${routes.deals}`}
          element={
            <PrivateRoute>
              <AppLayout>
                <Deals />
              </AppLayout>
            </PrivateRoute>
          }
        />

        <Route
          path={`${routes.viewAllOffers}`}
          element={
            <PrivateRoute>
              <AppLayout>
                <ViewALLOffers />
              </AppLayout>
            </PrivateRoute>
          }
        />

        <Route
          path={`${routes.viewAllCeo}`}
          element={
            <PrivateRoute>
              <AppLayout>
                <ViewAllCoe />
              </AppLayout>
            </PrivateRoute>
          }
        />

        <Route
          path={`${routes.dealsDetails}/:Id`}
          element={
            <PrivateRoute>
              <ResponsiveLayout>
                <DealsDetails />
              </ResponsiveLayout>
            </PrivateRoute>
          }
        />
        {/* Support */}
        <Route
          path={`${routes.support}`}
          element={
            <PrivateRoute>
              <AppLayout>
                <Support />
              </AppLayout>
            </PrivateRoute>
          }
        />
        <Route
          path={`${routes.request}`}
          element={
            <PrivateRoute>
              <AppLayout>
                <RaiseRequest />
              </AppLayout>
            </PrivateRoute>
          }
        />
        <Route
          path={`${routes.support}/:Id`}
          element={
            <PrivateRoute>
              <AppLayout>
                <RaiseEnquiry />
              </AppLayout>
            </PrivateRoute>
          }
        />
        <Route
          path={`${routes.Answers}`}
          element={
            <PrivateRoute>
              <AppLayout>
                <Answers />
              </AppLayout>
            </PrivateRoute>
          }
        />
        <Route
          path={`${routes.TicketPreview}`}
          element={
            <PrivateRoute>
              <AppLayout>
                <TicketPreview />
              </AppLayout>
            </PrivateRoute>
          }
        />
        <Route
          path={`${routes.faqs}`}
          element={
            <PrivateRoute>
              <AppLayout>
                <FAQs />
              </AppLayout>
            </PrivateRoute>
          }
        />
        <Route
          path={`${routes.faqs}/:Id`}
          element={
            <PrivateRoute>
              <AppLayout>
                <FaqQuestions />
              </AppLayout>
            </PrivateRoute>
          }
        />
        {/* Jury Portal */}

        <Route
          path="*"
          element={
            <PrivateRoute>
              <AppLayout>
                <Login />
              </AppLayout>
            </PrivateRoute>
          }
        />
      </Routes>
    </>
  );
};

export default MainLayout;
